import { hToggleArrayItem } from '@/utils/helpers';
import AgentSignature from '@/components/Common/AgentSignature';

// @vue/component
export default {
  name: 'BehaviorAgentsGroup',

  components: {
    AgentSignature,
  },

  props: {
    callBehaviorAgentsGroup: {
      validator: prop => typeof prop === 'string' || prop === null,
      required: true,
      default: '',
    },
    agentsList: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    selectedAgentsInGroup() {
      const agentsGroup = this.callBehaviorAgentsGroup;
      return agentsGroup ? agentsGroup.split(',') : [];
    },
  },

  methods: {
    toggleAgentInGroup(agentId) {
      const agentGroupBefore = this.callBehaviorAgentsGroup || '';
      const agentGroupAfter = hToggleArrayItem(agentGroupBefore.split(','), String(agentId)).filter(item => item);
      const newAgentsGroup = agentGroupAfter.join(',').length === 0 ? null : agentGroupAfter.join(',');
      this.$emit('change', newAgentsGroup);
    },
  },
};
